import { render, staticRenderFns } from "./ThreadMemberCard.vue?vue&type=template&id=a9b9f0f6&scoped=true"
import script from "./ThreadMemberCard.vue?vue&type=script&lang=js"
export * from "./ThreadMemberCard.vue?vue&type=script&lang=js"
import style0 from "./ThreadMemberCard.vue?vue&type=style&index=0&id=a9b9f0f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b9f0f6",
  null
  
)

export default component.exports